import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player/youtube";
import styles from "./VideoCard.module.scss";
import { Skeleton, Spin } from "antd";

const VideoCard = ({ videoUrl }) => {
  const [ready, setReady] = useState(false);

  return (
    <div className={styles["video-card"]}>
      <div style={{ display: ready ? "block" : "none" }}>
        <ReactPlayer
          width={window.screen.width < 480 ? "100%" : "400px"}
          height={window.screen.width < 480 ? "150px" : "225px"}
          url={videoUrl}
          controls={true}
          onReady={() => setReady(true)}
        />
      </div>
      {!ready && (
        <div
          className={styles["video-loader"]}
          style={{
            width: window.screen.width < 480 ? "100%" : "400px",
            height: window.screen.width < 480 ? "150px" : "225px",
          }}
        >
          <Skeleton.Input active />
        </div>
      )}
    </div>
  );
};

export default VideoCard;
